/**
 * 体験チケットの予約画面の URL。
 *
 * #2140 体験の店 (紹介ページの体験) は**別の URL** (`/trial/experience/buy/...`) で開く。
 * そちらはログインなし (ゲスト) で予約でき、当日払いだけ。本物の店の予約画面
 * (`/experience/buy/...`) はこれまでどおりログイン必須のまま (ルートで守る)。
 */
export function experienceBuyPath(productId: string, isTrialStore?: boolean): string {
  return isTrialStore ? `/trial/experience/buy/${productId}` : `/experience/buy/${productId}`
}
